import request from '@/utils/request'

// 旧 subtitle 到新后端 type 的映射表
const SUBTITLE_TO_TYPE = {
  zjsys: 'HOME',
  sysgk: 'LAB_OVERVIEW',
  sztd: 'FACULTY',
  sysdt: 'LAB_NEWS',
  sysdt2: 'LAB_NEWS',
  kxyj: 'RESEARCH',
  kypt: 'TECHNOLOGY_TRANSFER',
  xsfc: 'STUDENT',
  zsxx: 'ADMISSION'
}

function mapSubtitle (subtitle) {
  return SUBTITLE_TO_TYPE[subtitle] || subtitle
}

export const getBanner = (subtitle) => {
  const type = mapSubtitle(subtitle)
  return request.get(`/api/banner/${type}`).then(res => {
    // 后端返回字段为 url，前端期望 imageUrl，做字段映射
    if (res.code === 1 && res.data) {
      res.data.imageUrl = res.data.url
    }
    return res
  })
}

export const updateBanner = (data) => {
  // data 包含: { subtitle, imageUrl, ... }
  const type = mapSubtitle(data.subtitle || data.type)
  return request.put(`/api/banner/${type}`, {
    url: data.imageUrl || data.url
  })
}

// 获取所有 banner 分组（管理员用）
export const listBanners = () => {
  return request.get('/api/banner')
}
